module.exports = "/_next/static/images/5b286e58fefb6a9906cca91a8cb7747c-roxinho-single-md@2x.jpg.webp";